import { Injectable } from '@angular/core';
import { FormFactory } from "@magieno/angular-advanced-forms";

@Injectable()
export class ClientQuestionnaireResultBaseFactory {

  protected optionsType: { new(...args: any[]): object; };

  constructor(protected readonly formFactory: FormFactory) {
  }

  create() {
    return this.formFactory.create(new this.optionsType());
  }
}